import {
  Avatar,
  Box,
  Flex,
  FormLabel,
  Icon,
  Select,
  SimpleGrid,
  useColorModeValue,
} from "@chakra-ui/react";
// Assets
import Usa from "assets/img/dashboards/usa.png";
// Custom components
import MiniCalendar from "components/calendar/MiniCalendar";
import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import React from "react";
import { useEffect } from "react";
import {
  MdAddTask,
  MdAttachMoney,
  MdBarChart,
  MdFileCopy,
} from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { doctorAppointmentAllCount } from "../../../redux/actions/Admin.action";
import { useState } from "react";
import { Link } from 'react-router-dom';

export default function DoctorDashboard() {

  const dispatch = useDispatch()
  const counts = useSelector((state) => state.admin)
  const [currentDate, setCurrentDate] = useState('');

  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    setCurrentDate(formattedDate);
  }, []);

  useEffect(() => {
    if (currentDate) {
      dispatch(doctorAppointmentAllCount(currentDate));
    }
  }, [currentDate, dispatch]);

  const handleDateChange = (event) => {
    setCurrentDate(event.target.value);
  };

  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <div className='w-[200px] mb-4 ms-auto'>
        <label className="text-sm block mb-1">Date</label>
        <input
          type="date"
          name="date"
          value={currentDate}
          onChange={handleDateChange}
          className="w-75 outline-none !border-b"
        />
      </div>
      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3, "2xl": 4 }}
        gap='20px'
        mb='20px'>
        <MiniStatistics
        bgColor="#FFE4C4" // Light Yellow
          startContent={
            <IconBox
              w='56px'
              h='56px'
              className='text-theme-dark bg-[#F7EEE9]'
              icon={
                <Icon w='32px' h='32px' as={MdFileCopy} />
              }
            />
          }
          name='Total Appointment'
          value={counts?.doctorAppointmentCount?.data?.counts?.total}
        />
        <MiniStatistics
          bgColor="#F8E8E8" // Light Pink
          startContent={
            <IconBox
              w='56px'
              h='56px'
              className='text-theme-dark bg-[#F7EEE9]'
              icon={
                <Icon w='32px' h='32px' as={MdFileCopy} />
              }
            />
          }
          name='Confirm Appointment'
          value={counts?.doctorAppointmentCount?.data?.counts?.confirmed}
        />
        <MiniStatistics
          bgColor="#E8F8E8" // Light Green
          startContent={
            <IconBox
              w='56px'
              h='56px'
              className='text-theme-dark bg-[#F7EEE9]'
              icon={
                <Icon w='32px' h='32px' as={MdFileCopy} />
              }
            />
          }
          name='Pending Appointment'
          value={counts?.doctorAppointmentCount?.data?.counts?.pending}
        />
      </SimpleGrid>
    </Box>
  );
}
